/* unplugin-vue-components disabled */import script from "./StagePocket.vue?vue&type=script&setup=true&lang=js"
export * from "./StagePocket.vue?vue&type=script&setup=true&lang=js"

import "./StagePocket.vue?vue&type=style&index=0&id=59a2560a&scoped=true&lang=less"

import exportComponent from "/Users/zhangxuan/Documents/Projects/VinesDjango/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59a2560a"]])

export default __exports__